import Image from 'next/image';
import { imageSerializer } from '../../../../utils/imageSerializer';
import {
  Button,
  StageDescription,
  StageImageWrapper,
  StageTitle,
  StageWrapper,
  TextWrapper,
} from './stage.styles';
import { GetToKnowStage } from '../interfaces';
import { RichText } from 'prismic-reactjs';
import { useWindowSize } from '../../../../hooks/useWindowSize';

export const Stage = ({
  meet_us_image,
  meet_us_title,
  meet_us_description,
  isOpen,
  onClick,
}: GetToKnowStage) => {
  const { width } = useWindowSize();
  return (
    <StageWrapper isOpen={!!isOpen}>
      <TextWrapper>
        <StageTitle>{RichText.asText(meet_us_title)}</StageTitle>
        <StageDescription isOpen={!!isOpen}>
          {RichText.asText(meet_us_description)}
        </StageDescription>
        {RichText.asText(meet_us_description).length > 380 &&
          width &&
          width < 515 && (
            <Button onClick={onClick}>{!isOpen ? 'Rozwiń' : 'Zwiń'}</Button>
          )}
      </TextWrapper>
      <StageImageWrapper>
        <Image {...imageSerializer(meet_us_image)} />
      </StageImageWrapper>
    </StageWrapper>
  );
};
